<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="import_export_activities" />
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="file-import"></b-icon>
              <span> {{ $t('import_activities') }} </span>
            </template>
            <div>
              <import-entities-optimized :can-overwrite="true" :project-id="project_id" entity-type="activities">
                <template v-slot:descripcion>
                  <span class="text-orange-dark">{{ $t('activity_import_warning') }}</span>
                </template>
              </import-entities-optimized>
            </div>
          </b-tab-item>

          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="file-export"></b-icon>
              <span> {{ $t('export_activities') }} </span>
            </template>
            <div>
              <export-activities :project_id="project_id"></export-activities>
            </div>
          </b-tab-item>

          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="user"></b-icon>
              <span> {{ $t('assign_participants') }} </span>
            </template>
            <div>
              <import-entities :project-id="project_id" entity-type="participants" />
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="layer-group"></b-icon>
              <span> {{ $t('activity_groups') }} </span>
            </template>
            <div>
              <manage-groups-activities :projectId="project_id" :entityType="'project'"></manage-groups-activities>
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="clipboard-list"></b-icon>
              <span> {{ $t('scheduled_progress') }}</span>
            </template>
            <div class="w-full flex flex-row">
              <b-tabs type="is-toggle" expanded>
                <b-tab-item label="Progreso programado" icon="chart-pie" icon-pack="fas">
                  <div class="w-full flex flex-col">
                    <div class="w-full mb-3">
                      <b-field :label="$t('activity')+'/subactividad'">
                        <treeselect v-model="entity"
                          :placeholder="$t('select_or_type_to_search')"
                          :multiple="false"
                          :disabled="entities.length === 0"
                          :options="entities"
                          @select="(node, instanceId) => handleSelectActivity(node, instanceId)"
                        />
                      </b-field>
                    </div>
                    <div class="w-full mt-2">
                      <div class="w-full mt-8">
                        <div class="flex flex-row w-full text-blue font-bold">Avance Programado</div>
                        <div class="flex flex-row w-full"><line-chart :min="dataset.min"
                          :max="dataset.max"
                          :suffix="dataset.suffix"
                          :data="dataset.data" /></div>
                      </div>

                      <div class="w-full mt-8">
                        <div class="flex flex-row w-full text-blue font-bold">Avance Programado acumulado</div>
                        <div class="flex flex-row w-full"><line-chart
                            :min="cumulativeDataset.min"
                            :max="cumulativeDataset.max"
                            :suffix="cumulativeDataset.suffix"
                            :data="cumulativeDataset.data" /></div>
                      </div>

                      <div class="w-full mt-8">
                        <div class="flex flex-row w-full text-blue font-bold">Avance Programado Porcentual</div>
                        <div class="flex flex-row w-full"><line-chart
                          :min="0"
                          :max="100"
                          :suffix="'%'" :data="cumulativePercentageDataset.data" /></div>
                      </div>

                      <div class="w-full flex">
                        <div class="w-3/4 mt-2">
                          <div class="mb-2"><label>Progreso programado</label></div>
                          <table>
                            <tbody>
                              <tr class="panel" v-for="(line, key, index) in dataset.data[0].data" :key="'7_'+index">
                                <td align="center" class="justify-start py-2 w-5/12 bg-indigo-lightest">
                                  <span class="text-sm font-semibold text-blue">{{ key }}</span>
                                </td>
                                <td align="center" class="justify-start py-2 w-5/12 bg-grey-lightest">
                                  <span class="text-sm font-semibold">{{ line }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="w-3/4 mt-2">
                          <div class="mb-2"><label>Progreso programado acumulado</label></div>
                          <table>
                            <tbody>
                              <tr class="panel" v-for="(line, key, index) in cumulativeDataset.data[0].data" :key="'7_'+index">
                                <td align="center" class="justify-start py-2 w-5/12 bg-indigo-lightest">
                                  <span class="text-sm font-semibold text-blue">{{ key }}</span>
                                </td>
                                <td align="center" class="justify-start py-2 w-5/12 bg-grey-lightest">
                                  <span class="text-sm font-semibold">{{ line }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="w-3/4 mt-2">
                          <div class="mb-2"><label>Progreso acumulado porcentual</label></div>
                          <table>
                            <tbody>
                              <tr class="panel" v-for="(line, key, index) in cumulativePercentageDataset.data[0].data" :key="'7_'+index">
                                <td align="center" class="justify-start py-2 w-5/12 bg-indigo-lightest">
                                  <span class="text-sm font-semibold text-blue">{{ key }}</span>
                                </td>
                                <td align="center" class="justify-start py-2 w-5/12 bg-grey-lightest">
                                  <span class="text-sm font-semibold">{{ line }}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab-item>
                <b-tab-item label="Importar" icon="file-import" icon-pack="fas">
                  <div class="w-full">
                    <import-entities :project-id="project_id" :can-overwrite="true"  entity-type="planned-executions" />
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon pack="fas" icon="calendar-alt"></b-icon>
              <span> {{ $t('calendar') }} </span>
            </template>
            <div>
              <project-calendar v-if="mainActiveTab === 5" :project-id="project_id" />
            </div>
          </b-tab-item>

        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex'

import ImportEntitiesOptimized from '../../components/import-entities-optimized.vue'
import ImportEntities from '../../components/import-entities.vue'
import exportActivities from '../../components/export-activities'
import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
import ManageGroupsActivities from '../../components/activity-groups/manage-groups-activities.vue'
import ProjectCalendar from '../../components/project-calendar.vue'

// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    ImportEntitiesOptimized,
    exportActivities,
    ProjectAdminQuickButtons,
    ManageGroupsActivities,
    ImportEntities,
    Treeselect,
    ProjectCalendar,
  },
  middleware: "auth",
  title: "import_export_activities",
  menuOption: "0-2",

  computed: {
    ...mapGetters({
      navData: 'app/navData',
    }),
  },

  data: () => ({
    project_id: null,
    mainActiveTab: 0,

    entity: null, // entidad a la cual se esta asignando la salida (actividad, incidencia, recurso, etc)
    entities: [], // lista de las entidades a seleccion
    dataset:  {
      'name': null,
      'max': 1,
      'min': 0,
      'suffix': 'ud.',
      'data': [
        {
          name: 'Avance Programado',
          data: []
        }
      ]
    },

    cumulativeDataset: {
      'name': null,
      'max': 1,
      'min': 0,
      'suffix': 'ud.',
      'data': [
        {
          name: 'Avance Programado',
          data: []
        }
      ]
    },

    cumulativePercentageDataset: {
      'name': null,
      'max': 0,
      'min': 100,
      'suffix': '%',
      'data': [
        {
          name: 'Avance Programado',
          data: []
        }
      ]
    },
  }),

  created() {
    this.$options.subtitle = ['project_actions_page_subtitle', [this.navData.project_name.toUpperCase()]]
    this.project_id = this.navData.project_id

    this.getEtitiesProject()
  },

  methods: {

    handleSelectActivity (node, instanceId) {
      this.getDataset(node.id)
    },

    async getEtitiesProject() {
      this.entities = []
      let params = {
        p: this.project_id,
        s: 1,
        per_page: 999
      }

      const {data} = await axios.get('/api/v2/activities', { params: params })
      if (data && data.success) {
        this.entities = this.getDataEntity(data)
      } else {
        this.$notify.error('error_retreiving_measures')

      }
    },

    getDataEntity(response){
      let entities = []

      response.activities.forEach(item => {
        let entity = {
          id: item.id,
          label: item.name,
          type: 'activity',
          code: item.planning_code,
          children: []
        }

        if( item.subactivities.length ){
          entity.children = item.subactivities.map( subactivity => {
            return { id: subactivity.id, label: subactivity.name, code: subactivity.planning_code, type: 'subactivity' }
          })
        }

        entities.push(entity)
      });

      return entities;
    },

    async getDataset(activity_id) {
      this.dataset = {
        'name': null,
        'max': 0,
        'min': 0,
        'suffix': 'ud.',
        'data': [
          {
            name: 'Avance Programado',
            data: []
          }
        ]
      }
      let params = {
        project_id: this.project_id,
        activity_id: activity_id
      }

      const {data} = await axios.get('/api/v2/planned-progress/dataset', { params: params })
      if (data && data.success) {
        this.dataset = data.data.progress
        this.cumulativeDataset = data.data.accumulated
        this.cumulativePercentageDataset = data.data.percentage
      } else {
        this.$notify.error('error_retreiving_measures')

      }
    }
  },
};

</script>
